export enum Role {
  Customer = 'E2E.CUSTOMER',
  Efficiency = 'E2E.EFFICIENCY',
  Energy = 'E2E.ENERGY',
  Inventory = 'E2E.INVENTORY',
  Kpi = 'E2E.KPI',
  Mobile = 'E2E.MOBILE',
  Operation = 'E2E.OPERATION',
  Planning = 'E2E.Planung',
  Production = 'E2E.PRODUCTION',
  Quality = 'E2E.QUALITY',
  Ssot = 'E2E.SSOT',
}
